<template>
  <div class="padding-left">
    <fieldset id="component-p-2" role="tabpanel" aria-labelledby="component-h-2" class="body" aria-hidden="true">
      <h4>{{ $t('companyReadme.notice') }}</h4>
      <div style="max-height:500px;overflow-y:auto">
        <div v-html="companyReadmeInfo.content"></div>
      </div>
      <br />
      <el-checkbox v-model="companyReadmeInfo.acceptTerms">
        {{ $t('companyReadme.agreeNotice') }}
      </el-checkbox>
    </fieldset>
  </div>
</template>

<script>
import { listRegisterProtocol } from '@/api/common/companyApi'

export default {
  name: 'CompanyReadme',
  data() {
    return {
      companyReadmeInfo: {
        acceptTerms: false,
        content: ''
      }
    }
  },
  created() {
    this._loadReadmeText()
  },
  watch: {
    companyReadmeInfo: {
      deep: true,
      handler() {
        this.$emit('company', 'notifyCompanyReadme', this.companyReadmeInfo)
      }
    }
  },
  methods: {
    async _loadReadmeText() {
      try {
        const res = await listRegisterProtocol({ page: 1, row: 1 })
        if (res.data && res.data.length > 0) {
          this.companyReadmeInfo.content = res.data[0].merchantProtocol
        }
      } catch (error) {
        console.error('获取协议内容失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.padding-left {
  padding-left: 20px;
}
</style>